export const SLIDES_INDICATOR_ID = 'SlidesIndicator';

export const INDICATOR_DOTS_NUMBER = 4;
